export const COLLECTION_NAME = 'timesheets';

// Hardcoded APP_ID ensures all clients access the same Firebase data
export const APP_ID = 'founder-timesheet-app';

export const FOUNDERS = [
    'Naeem Theyyathumkadavath',
    'Saeed Abdu Rahiman',
    'Shafeeque Kokkuth',
    'Abdu Subahan'
];

export const PREDEFINED_TASKS = [
    "Easy Escape - Itinerary",
    "Easy Escape - Client Meeting",
    "Easy Escape - Ads Creation",
    "Easy Escape - Management",
    "Easy Escape - Customer Support",
    "Flyeurope DMC - Itinerary",
    "Flyeurope DMC - Client Meeting",
    "Flyeurope DMC - Ads Creation",
    "Flyeurope DMC - Management",
    "Flyeurope DMC - Customer Support",
    "Others"
];

export const COUNTRY_CODES = [
    { code: '+1', country: 'USA', flag: '🇺🇸' },
    { code: '+44', country: 'UK', flag: '🇬🇧' },
    { code: '+91', country: 'IND', flag: '🇮🇳' },
    { code: '+971', country: 'UAE', flag: '🇦🇪' },
    { code: '+1', country: 'CAN', flag: '🇨🇦' },
    { code: '+61', country: 'AUS', flag: '🇦🇺' },
    { code: '+49', country: 'GER', flag: '🇩🇪' },
    { code: '+33', country: 'FRA', flag: '🇫🇷' },
    { code: '+81', country: 'JPN', flag: '🇯🇵' },
    { code: '+86', country: 'CHN', flag: '🇨🇳' },
    { code: '+55', country: 'BRA', flag: '🇧🇷' },
    // Add more as needed
];
